module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Death-Of-Stalin-The.9a989b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Death-Of-Stalin-The.jpg
// module id = ZS+7
// module chunks = 0